export default __webpack_public_path__ + "static/UW-Stout_20190622_152336-26ab925ccc2598cf906f0819edbac2cd.jpg";